import request from '@/utils/request'

export function selectPanel(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/setPanel/selectPanel?access=${data}`,
        method: 'post',
       // data,
    })
}

export function upDatePanel(data) {
    return request({
        url: `api/serviceCenter/setPanel/upDatePanel`,
        method: 'post',
        data,
    })
}

export function bathDeleteCarving(data) {
    return request({
        url: `api/serviceCenter/setPanel/bathDeleteCarving`,
        method: 'post',
        data,
    })
}
